/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Fjn_More_Than_2511Inputs */

const en__field_enum_fjn_more_than_2511 = /** @type {(inputs: _Field_Enum_Fjn_More_Than_2511Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`>25 km`)
};

const de__field_enum_fjn_more_than_2511 = /** @type {(inputs: _Field_Enum_Fjn_More_Than_2511Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`>25 km entfernt`)
};

/**
* | output |
* | --- |
* | ">25 km" |
*
* @param {_Field_Enum_Fjn_More_Than_2511Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_fjn_more_than_2511 = /** @type {((inputs?: _Field_Enum_Fjn_More_Than_2511Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Fjn_More_Than_2511Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_fjn_more_than_2511(inputs)
	return de__field_enum_fjn_more_than_2511(inputs)
});
export { _field_enum_fjn_more_than_2511 as "_field_enum_FJN_MORE_THAN_25" }